module.exports = __webpack_public_path__ + "static/scale-model-of-at&t-stadium-in-arlington-texas-e4e446d28bd4eac1dbca2cbca1252bf9.png";